import Grid from "@mui/material/Grid";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { FC, useContext } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { useFilteredLegalEntityAndDealer } from "../../service/useFilteredLegalEntityAndDealer";
import { DatePicker } from "@mui/x-date-pickers";


interface UserLegalEntitiesOrDealersInputGroupProps {
    control?: any;
    disabled?: boolean;
    tenantId?: string;
    dealerId?: string;
    itemWrappercolumns?: number;
    itemColumns?: number;
    hasCreatedDateFieldInsideVoucherDetail?: boolean;
    hasCreatedDateFieldInsideVoucherUpdate?: boolean;
    createdDateValue?: string;
}


export const UserLegalEntitiesOrDealersInputGroup: FC<UserLegalEntitiesOrDealersInputGroupProps> = ({
                                                                                                        control,
                                                                                                        disabled,
                                                                                                        tenantId,
                                                                                                        dealerId,
                                                                                                        itemWrappercolumns = 12,
                                                                                                        itemColumns = 3,
                                                                                                        hasCreatedDateFieldInsideVoucherDetail = false,
                                                                                                        hasCreatedDateFieldInsideVoucherUpdate = false,
                                                                                                        createdDateValue
                                                                                                    }) => {
    const { globalData } = useContext(GlobalContext);

    const { filteredLegalEntities, filteredDealers } = useFilteredLegalEntityAndDealer();

    const { t } = useTranslation(["salesmarketing"]);

    const controlInputsLegalEntitiesNotReadOnly = <>
        <Controller
            control={control}
            name={"tenantId"}
            render={({ field, fieldState }: any) => (
                <TextField
                    fullWidth
                    label={t("legalEntityField")}
                    select
                    disabled={disabled}
                    value={field.value}
                    onChange={field.onChange}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                >
                    {filteredLegalEntities.map(((le: any) => (
                        <MenuItem key={le.name} value={le.name}>
                            <ListItemText primary={le.name} />
                        </MenuItem>
                    )))}
                </TextField>
            )} />
    </>;
    const controlInputsLegalEntitiesReadOnly = <>
        <TextField
            fullWidth
            label={t("legalEntityField")}
            value={tenantId}
            inputProps={
                { readOnly: true }
            }
        >
            {filteredLegalEntities.map(((le: any) => (
                <MenuItem key={le.name} value={le.name}>
                    <ListItemText primary={le.name} />
                </MenuItem>
            )))}
        </TextField>
    </>;
    const controlInputsDealersNotReadOnly = <>
        <Controller
            control={control}
            name={"dealerId"}
            render={({ field, fieldState }: any) => (
                <TextField
                    fullWidth
                    label={t("dealerField")}
                    select
                    disabled={disabled}
                    value={field.value}
                    onChange={field.onChange}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                >
                    {filteredDealers.map(((le: any) => (
                        <MenuItem key={le.name} value={le.name}>
                            <ListItemText primary={le.name} />
                        </MenuItem>
                    )))}
                </TextField>
            )} />
    </>;
    const controlInputsDealersReadOnly = <>
        <TextField
            fullWidth
            label={t("dealerField")}
            value={dealerId}
            inputProps={
                { readOnly: true }
            }
        >
            {filteredDealers.map(((le: any) => (
                <MenuItem key={le.name} value={le.name}>
                    <ListItemText primary={le.name} />
                </MenuItem>
            )))}
        </TextField>
    </>;

    const hasCreatedDateFieldInsideVoucherUpdateContent = <Controller
        control={control}
        name={"createdDate"}
        render={({ field }: any) => (
            <DatePicker
                label={t("voucher.inputUpdatePageFields.createdDate")}
                value={field.value}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        disabled
                        sx={{ marginTop: "17px" }}
                    />}
                inputFormat={"L HH:mm"}
                disabled
                onChange={field.onChange}
            />
        )} />;
    const hasCreatedDateFieldInsideVoucherDetailContent =
        <DatePicker
            label={t("voucher.inputUpdatePageFields.createdDate")}
            value={createdDateValue}
            renderInput={(params) =>
                <TextField
                    {...params}
                    fullWidth
                    label={t("voucher.inputDetailPageFields.createdDate")}
                    value={createdDateValue}
                    margin="dense"
                    variant="standard"
                />}
            inputFormat={"L HH:mm"}
            disabled
            onChange={() => {
                return;
            }}
        />;
    return <>
        {(globalData?.user?.legalEntities?.length > 1 || globalData?.user?.dealers?.length > 1) && <>
            <Grid container item xs={itemWrappercolumns} spacing={1}>
                {globalData?.user?.legalEntities?.length > 1 &&
                    <Grid item xs={itemColumns}>
                        {control ? controlInputsLegalEntitiesNotReadOnly : controlInputsLegalEntitiesReadOnly}
                    </Grid>
                }
                {globalData?.user?.dealers?.length > 1 &&
                    <Grid item xs={itemColumns}>
                        {control ? controlInputsDealersNotReadOnly : controlInputsDealersReadOnly}
                    </Grid>
                }
            </Grid>
        </>

        }
        {(hasCreatedDateFieldInsideVoucherDetail || hasCreatedDateFieldInsideVoucherUpdate) &&
            <Grid item xs={3}>
                {hasCreatedDateFieldInsideVoucherUpdate && hasCreatedDateFieldInsideVoucherUpdateContent}
                {hasCreatedDateFieldInsideVoucherDetail && hasCreatedDateFieldInsideVoucherDetailContent}
            </Grid>
        }
    </>;
};

export function preselectSingleEntity(globalData: any, setValue: any) {
    if (globalData?.user?.legalEntities?.length === 1) {
        setValue('tenantId', globalData.user.legalEntities[0].name);
    }
    if (globalData?.user?.dealers?.length === 1) {
        setValue('dealerId', globalData.user.dealers[0].name);
    }
}